import axios from "axios";
import store from "@/store/vuex";
const server_uri = process.env.VUE_APP_SERVER_URI;


export function default_post(body, path) {
    return new Promise((resolve, reject) => {
      const config = {
        headers: {
          Authorization: `Bearer ${store.getters.getSACIToken}`
        } // Obtem access_token
      };
  
      axios
        .post(`${server_uri}${path}`, body, config)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err);
          reject([]);
        });
    });
  }

  export function default_get(path) {
    return new Promise((resolve, reject) => {
      
      const config = {
        headers: {
          Authorization: `Bearer ${store.getters.getSACIToken}`
        } // Obtem access_token
      };
  
      axios
        .get(`${server_uri}${path}`, config)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err);
          reject([]);
        });
    });
  }
  